module.exports = __webpack_public_path__ + "img/logo_bnbchain.aee8cd44.png";